 // kdx-nav-basic {

    //     flex: 1 1 auto;

    // }
    .basic-nav {
        display: flex;
        justify-content: flex-end;
        text-align: center;

        &__parent {
            display: flex;
            align-items: center;
        }

        &__parent-link {
            color: #000;
            @include text-size(20);
            font-weight: 600;
            text-decoration: none;
            padding: 8px 20px 16px 20px;
            display: inline-block;
            border-bottom: 4px solid transparent;
            transition: border-bottom .3s, color .3s;
        }

        &__toggle {
            margin-left: 10px;
            display: none;

            svg {
                @include svg-format(12px, 12px, $primary);
                transition: all 350ms;
            }
        }

        &__children {
            display: none;
            position: absolute;
            width: 260px;
            right: 0;            
            background: #fff;
            opacity: 0;
            transform: translateY(10px);
            box-shadow: 0px 7px 9px rgba(0, 0, 0, 0.16);
            z-index:10001;
        }

        &__child-link {
            display: block;            
            text-decoration: none;
            @include text-size(16);
            @include line-height(20);
            color: $submenuChildLink;
            padding: 13px 16px;
            border-bottom: 1px solid #EFEFEF;
            transition: background .2s, color .2s;

            &:hover, &:focus {
                color: $submenuHoverText;
                background: $submenuHoverBG;
            }
        }

        &__node {
            position: relative;
            padding: 0;
            
            &:nth-child(-n+2) {
                .basic-nav__children {
                    right: initial;
                    left: 0;
                }
            }

            &.opened {
                .basic-nav__parent-link {
                    color: $menuTopLevelHover;
                    border-bottom: 4px solid $menuTopLevelBorder;
                }
                .basic-nav__toggle {
                    svg {
                        fill: $quarternary;
                        transform: rotate(180deg);
                    }
                }
                .basic-nav__children {
                    display: block;
                    animation: childNavIn 200ms linear forwards; 
                }
            }
        }

        &__mobile-util-nav {
            display: none;
        }
    }

@include media-breakpoint-down(xl) {
        
    .basic-nav__parent-link {
        @include text-size(15);
        text-align: center;
    }

}

@include media-breakpoint-down(lg) {
    .basic-nav {
        background: #fff;
        padding-bottom: 40px;
        margin-left: -40px;
        margin-right: -40px;
        flex-direction: column;       

        a {
            user-select: none;
        }

        &__parent {
            display: flex;
            align-items: center;
            justify-content: space-between;            
            border-bottom: 1px solid #ccc;
            padding-right: 40px;
            padding-left: 10px;
        }

        &__parent-link {
            color: #000;
            @include text-size(18);
            @include line-height(23);
            font-family: $font-family-secondary;
            font-weight: 600;
            text-decoration: none;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 15px 35px;
        }

        &__children {
            display: none;
        }

        &__toggle {
            cursor: pointer;
            position: relative;
            z-index: 10000;
            display: block;

            svg {
                @include svg-format(14px, 14px, currentColor);
                transition: all 350ms;
            }
        }

        // .opened .closed {
        //     display: flex;
        //     flex-direction: column;
        //     padding-left: 20px;
        // }

        &__node {
            &.opened {
                .basic-nav__parent { 
                    border-bottom: 3px solid $primary; 
                    
                    .basic-nav__parent-link {
                        color: $primary;
                        border-bottom: none;
                    }
                }
                .basic-nav__children {
                    position: relative;
                    display: block;
                    padding: 15px 15px 15px 46px;
                    border-bottom: 1px solid #ccc;
                    box-shadow: none;
                    width: 100%;

                    & > div {
                        padding: 10px 0;
                    }
                    
                    .basic-nav__child-link {
                        color: $primary;
                        @include text-size(16);
                        @include line-height(20);
                        font-family: $font-family-secondary;
                        text-decoration: none;
                        border-bottom: none;
                        margin-right: 50%;
                        text-align: left;

                        &:hover, &:focus, &:active {
                            color: #fff;
                        }
                    }                
                }
            }
        }

        &__mobile-util-nav {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            padding: 15px;

            a.util-link {
                display: inline-block;
                margin: 5px 10px;
                font-size: 13px;
                font-weight: 700;
                text-transform: uppercase;
                color: $primary;
                text-decoration: none;
            
                svg {
                    @include svg-format(14px, 14px, $primary);
                    transform: translate(0, -1px);
                    margin-left: 7px;
                    transition: transform 350ms;
                }
            
                &:hover {
                    svg {
                    transform: translate(5px, -1px);
                    }
                }
            }
        }
    }
}

@keyframes childNavIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
